<div
  *ngIf="(remoteDiagnosticsStore.getActiveConnectionStep$ | async) !== modalStep.CONNECTION_FAILED"
>
  <div class="loader" *ngIf="isAnyFromSnapshotVddLoading">
    <mat-icon class="loop">loop</mat-icon>
    <div class="flex flex-col justify-around items-center">
      <p>
        {{ '+REMOTE_DIAGNOSTICS_BACKUPS.READING_VDD_VALUES_TEXT' | translate }}
        {{ remoteDiagnosticsSnapshotsStore.howManySnapshotVddLoaded$ | async }} /
        {{ remoteDiagnosticsSnapshotsStore.installationVddListLength$ | async }}
      </p>
    </div>
  </div>
</div>
